export default __webpack_public_path__ + "static/media/pikachu.6c943090.png";